import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

function renderSwitchEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Toggle Labels</h4>
      <p className="af-properties-tab__hint" style={{ marginBottom: '8px' }}>
        Displayed beside the toggle to describe the on/off states.
      </p>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          On Label <span className="af-properties-tab__hint">shown when enabled</span>
          <input
            type="text"
            value={(control.config?.onLabel as string) || ''}
            onChange={(e) => onConfigChange('onLabel', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="e.g. Yes / Active / Enabled"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Off Label <span className="af-properties-tab__hint">shown when disabled</span>
          <input
            type="text"
            value={(control.config?.offLabel as string) || ''}
            onChange={(e) => onConfigChange('offLabel', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="e.g. No / Inactive / Disabled"
          />
        </label>
      </div>
    </div>
  );
}

export const SwitchEditor: PropertyEditor = {
  type: 'switch',
  label: 'Switch',
  description: 'Configure on/off labels for toggle control',
  render: renderSwitchEditor,
};
